import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'wouter';
import Container from '@mui/material/Container';
import StaticLoader from '../../components/mui/MuiLoader/StaticLoader/StaticLoader';
import AuthContext from '../../auth/AuthContext';
import { ROUTES } from '../../constants/routes';

const Login = () => {
  const { t } = useTranslation();
  const msalInstance = useContext(AuthContext);
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (msalInstance.getActiveAccount() && location) {
      setLocation(ROUTES.DASHBOARD);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {t('meta.title')} {t('loginPage.title')}
        </title>
      </Helmet>
      <Container maxWidth="xs">
        <StaticLoader />
      </Container>
    </>
  );
};

export default Login;
